import type { Config } from "../types"
import { parse } from "query-string"

type Param = string | string[] | null | undefined
const extractParam = (str: Param): string | undefined => {
  if (Array.isArray(str)) return str[0]

  return str || undefined
}

const extractAdvisorId = (val: Param): string => {
  const param = extractParam(val)

  return param !== undefined && param.length > 1 ? param.trim() : ""
}

const extractPreview = (val: Param): boolean => {
  const param = extractParam(val)
  return param === "true" ? true : false
}

const extractMode = (val: Param): Config["mode"] => {
  const param = extractParam(val) || ""

  return ["inpage", "modal", "banner", "sidebar"].includes(param)
    ? (param as Config["mode"])
    : "modal"
}
const extractTransparent = (val: Param): boolean => {
  const param = extractParam(val)
  return param === "true" ? true : false
}

const extractIntroContent = (val: Param): Config["introContent"] => {
  const param = extractParam(val)
  return param === "minimal" ? "minimal" : "full"
}

const extractProductScope = (
  id: Param,
  uri: Param
): Config["productScope"] | undefined => {
  const idParam = extractParam(id)
  const uriParam = extractParam(uri)

  if (idParam) return { type: "product-id", id: idParam }
  if (
    uriParam &&
    (uriParam.startsWith("https://") || uriParam.startsWith("http://"))
  ) {
    try {
      new URL(uriParam)
      return { type: "product-url", url: uriParam }
    } catch {
      return
    }
  }

  return
}

export const parseConfig = (url: string): Config => {
  const {
    advisorId: advisorIdParam,
    preview: previewParam,
    mode: modeParam,
    transparent: transparentParam,
    introcontent: introContentParam,
    productId: productIdParam,
    productUrl: productUriParam,
  } = parse(url)

  const advisorId = extractAdvisorId(advisorIdParam),
    isPreview = extractPreview(previewParam),
    mode = extractMode(modeParam),
    transparent = extractTransparent(transparentParam),
    introContent = extractIntroContent(introContentParam),
    productScope = extractProductScope(productIdParam, productUriParam)

  return {
    advisorId,
    isPreview,
    mode,
    isProductCheck: !!productScope,
    transparent,
    introContent: mode === "banner" ? introContent : "full" ,
    productScope,
  }
}
